import React from 'react';
import { TTemplate } from '@/helpers/createTemplate';
import Card from '../Card';
import {
  FlexFeatureWrapper,
  FlexFeatureTitleWrapper,
  FlexFeatureCardWrapper,
  HeadingSlogan,
} from '../styles/Featured.styles';
import baseTemplate from './template.default';

const template: TTemplate = {
  wrapper: <FlexFeatureWrapper />,
  feature: (
    <FlexFeatureTitleWrapper>
      <HeadingSlogan>Featured race</HeadingSlogan>
    </FlexFeatureTitleWrapper>
  ),
  card: (
    <FlexFeatureCardWrapper>
      <Card />
    </FlexFeatureCardWrapper>
  ),

  ...(baseTemplate?.first as TTemplate),
};

export default template;
